import React from 'react';
import { Chip } from '@mui/material';
import { cx } from '@emotion/css';
import { useStyles } from './Label.styles';
export function Label(props) {
    const { children, className, id, onClick, variant } = props;
    const classes = useStyles();
    return (React.createElement(Chip, { className: cx(className, classes.root, { [variant]: true }), id: id, size: "small", label: children, onClick: onClick }));
}
//# sourceMappingURL=Label.js.map